import React from "react";

import BasePersonelServiceItem from "./BasePersonelServiceItem";
import { SERVICE_TYPES } from "@routebot/constants";

// #region Utils

// #endregion Utils

const ShiftPersonelServiceItem = ({ itemId, onClose, isNewItem, gotoItem, DeleteItem, UpdateItem, InsertItem }) => {
  const config = {
    // Context data key
    contextDataKey: "shiftPersonelServices",

    // Form fields
    hasShift: true,
    hasDate: true,
    serviceType: SERVICE_TYPES.SHIFT,
  };

  return (
    <BasePersonelServiceItem
      itemId={itemId}
      onClose={onClose}
      isNewItem={isNewItem}
      gotoItem={gotoItem}
      DeleteItem={DeleteItem}
      UpdateItem={UpdateItem}
      InsertItem={InsertItem}
      config={config}
    />
  );
};

export default ShiftPersonelServiceItem;
